export enum PagePathStorageKey {
    CurrentPath = 'currentPath',
    PrevPath = 'prevPath',
    Base = 'base',
}
